export const ErrorCodes = {
  // Role and seat management
  ROLE_SEATS_EXCEEDED: 'ROLE_SEATS_EXCEEDED',
  ROLE_NOT_FOUND: 'ROLE_NOT_FOUND',
  UNSUPPORTED_ROLE: 'UNSUPPORTED_ROLE',
  MISSING_REQUIRED_ROLE: 'MISSING_REQUIRED_ROLE',
  DUPLICATE_ROLE_DEFINITION: 'DUPLICATE_ROLE_DEFINITION',
  ROLE_REMOVAL_NOT_SUPPORTED: 'ROLE_REMOVAL_NOT_SUPPORTED',
  CANNOT_REDUCE_SEATS: 'CANNOT_REDUCE_SEATS',
  CANNOT_INCREASE_SEATS: 'CANNOT_INCREASE_SEATS',

  // Invite management
  INVITE_EXPIRED: 'INVITE_EXPIRED',
  INVITE_ALREADY_ACCEPTED: 'INVITE_ALREADY_ACCEPTED',
  INVITE_NOT_FOUND: 'INVITE_NOT_FOUND',

  // Identity and assignments
  IDENTITY_ALREADY_HAS_ROLE: 'IDENTITY_ALREADY_HAS_ROLE',

  // Validation
  INVALID_SUBSCRIPTION_ID: 'INVALID_SUBSCRIPTION_ID',
  INVALID_ACCOUNT_ID: 'INVALID_ACCOUNT_ID',
  INVALID_VALUE_OBJECT: 'INVALID_VALUE_OBJECT',

  // Entity
  ENTITY_NOT_FOUND: 'ENTITY_NOT_FOUND',
} as const;

export type ErrorCode = (typeof ErrorCodes)[keyof typeof ErrorCodes];
